import { render, staticRenderFns } from "./successDialog.vue?vue&type=template&id=f20de6f2&scoped=true"
import script from "./successDialog.vue?vue&type=script&lang=js"
export * from "./successDialog.vue?vue&type=script&lang=js"
import style0 from "./successDialog.vue?vue&type=style&index=0&id=f20de6f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20de6f2",
  null
  
)

export default component.exports